import StoreOutlinedIcon from "@mui/icons-material/StoreOutlined";
import React, { useState, useEffect } from "react";
import { Column, DataGrid, Export, FilterPanel, FilterRow, HeaderFilter, SearchPanel, Selection } from "devextreme-react/data-grid";
import { LoadPanel } from "devextreme-react";

export const WidgetVentasDelDiaPorFormaDePago = ({ Fecha, WidgetKey }) => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([])
  const { Varios: { FormateoFechaPara_yyyyMMdd } } = require('neftis7_apicaller');
  const { VEN_Recibos_Cabecera: { function_VEN_Recibos_Cabecera_LeerPorFecha } } = require('neftis7_apicaller');

  const getData = async () => {
    // Llama a función asíncrona y maneja los datos
    try {
      const resultData = await function_VEN_Recibos_Cabecera_LeerPorFecha(await FormateoFechaPara_yyyyMMdd(Fecha), await FormateoFechaPara_yyyyMMdd(Fecha));
      setData(resultData.data || [])
    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
    setLoading(false)

  };

  useEffect(() => {
    getData();
  }, [Fecha, WidgetKey]);

  const dataFinal = []


  return (
    <div>
      <div className="widgetDobleAlto">
        <div className="title">
          <StoreOutlinedIcon
            className="icon"
            style={{
              backgroundColor: "rgba(0, 128, 0, 0.2)",
              color: "green",
              width: "30px",
              height: "30px",
              margin: "0px 15px 0px 0px "
            }}
          />{" "}
          VENTAS F. PAGO
        </div>
        <br />
        {data && data.length > 0 && (
          <DataGrid
            style={{ fontSize: '11px', fontFamily: 'Tahoma, sans-serif' }}
            showRowLines={false}
            showBorders={true}
            allowColumnResizing={false}
            rowAlternationEnabled={true}
            dataSource={data}
            height={355}
            scrolling={{ mode: "standard" }}
          >
            <HeaderFilter visible={false} />
            <FilterPanel visible={false} />
            <FilterRow visible={false} />
            <Export enabled={false} allowExportSelectedData={false} />
            <SearchPanel visible={false} />
            <LoadPanel enabled={true} />

            <Column caption="Código" dataField="CodigoCuentaFinanciera" width="70" alignment="Left" dataType="string" visible={false} />
            <Column caption="Descripción" dataField="CuentaFinanciera" width="140" alignment="Left" dataType="string" />
            <Column caption="Importe" dataField="Importe" width="100" alignment="Right" dataType="number" format="currency" />
          </DataGrid>
        )}
        <br />
        <a href={"VEN_DocsVenta_"} className="tituloLink">
          Ver Ventas
        </a>
      </div>
    </div>
  );
};
